import React, { useEffect, useState } from "react";
import { Button, Col, Icon } from "../../../../../../components/Component";
import { Alert, Spinner } from "reactstrap";
import { Link } from "react-router-dom";
import { employee_dashboard_actions_helper } from "../../../../../../actions/actions_helper";
import {
  fail_active_users_list,
  loading_active_users_list,
  reset_active_users_list,
  success_active_users_list,
} from "../../../../../../reducers/dashboard_reducers/user/active_users_list_Slice";
import {
  RETRIEVE_ACTIVE_USERS_ACCESS_DENIED_MSG,
  RETRIEVE_ACTIVE_USERS_ERR_MSG,
  RETRIEVE_ACTIVE_USERS_SUCCESS_MSG,
} from "../../../../../../constants/success_error_messages_consts";
import { RETRIEVE_ACT_COMP_KYC_LIST_NO_COMP_ACCS_API } from "../../../../../../api/api_data";
import { useDispatch, useSelector } from "react-redux";
import * as app_consts from "../../../../../../constants/react_app_consts";
import TextInput from "../../../../../components/inputs/TextInput";
import { BiErrorCircle } from "react-icons/bi";
import ReadOnlyTable from "../../../table/ReadOnlyTable";

const type = app_consts.ONBOARD_COMPANY_SEARCH;

const ModalOnboardCompanySearch = ({ isOpen, setIsOpen }) => {
  const [errorVal, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [selectedUser, setSelectedUser] = useState("");

  const dispatch = useDispatch();
  const [user_list, setUserList] = useState([]);
  const [user_data, setUserData] = useState([]);
  const [onSearchText, setOnSearchText] = useState("");
  const [listError, setListError] = useState("");

  // CHANGED: was initialized as [] but later treated as an object
  const [selected_data, setSelectedData] = useState(null);

  useEffect(() => {
    if (isOpen) {
      retrieveActiveUsersList();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isOpen]);

  const retrieveActiveUsersList = () => {
    dispatch(
      employee_dashboard_actions_helper(
        loading_active_users_list,
        success_active_users_list,
        fail_active_users_list,
        RETRIEVE_ACTIVE_USERS_ERR_MSG,
        RETRIEVE_ACTIVE_USERS_SUCCESS_MSG,
        app_consts.GET,
        RETRIEVE_ACT_COMP_KYC_LIST_NO_COMP_ACCS_API,
        null,
        RETRIEVE_ACTIVE_USERS_ACCESS_DENIED_MSG
      )
    );
  };

  const active_users_list = useSelector(
    (state) => state.active_users_list.active_users_list
  );

  useEffect(() => {
    if (active_users_list.status !== app_consts.IDLE) {
      if (active_users_list.status === app_consts.LOADING) {
        setListError("");
        setLoading(true);
      } else {
        setLoading(false);

        if (active_users_list.status === app_consts.FAIL) {
          setListError(active_users_list.message);
        } else if (active_users_list.status === app_consts.SUCCESS) {
          // CHANGED: ensure data is always an array
          const data = Array.isArray(active_users_list.data)
            ? active_users_list.data
            : [];
          setUserList(data);
          setUserData(data);
        }

        dispatch(reset_active_users_list());
      }
    }
  }, [active_users_list, dispatch]);

  const onActionText = (val) => {
    if (selectedUser) setSelectedUser("");
    setSelectedData(null);
    setOnSearchText(val);
  };

  // CHANGED: helper to safely convert null/undefined to lowercase string
  const safeLower = (value) =>
    (value ?? "").toString().toLowerCase();

  useEffect(() => {
    // CHANGED: search text is normalized once
    const query = safeLower(onSearchText).trim();

    if (query) {
      const filteredObject = (user_data ?? []).filter((item) => {
        // CHANGED: all searchable fields go through safeLower
        return (
          safeLower(item?.first_name).includes(query) ||
          safeLower(item?.surname).includes(query) ||
          safeLower(item?.phone_number).includes(query) ||
          safeLower(item?.email_address).includes(query)
        );
      });

      setUserList(filteredObject);
    } else {
      setUserList(user_data ?? []);
      setOnSearchText("");
    }
  }, [onSearchText, user_data]);

  const refreshList = () => {
    retrieveActiveUsersList();
    setListError("");
    setSelectedUser("");
    setSelectedData(null);
  };

  useEffect(() => {
    // CHANGED: guard against null before reading phone_number
    if (selected_data && selected_data?.phone_number != null) {
      setSelectedUser(selected_data.phone_number.toString());
    } else {
      setSelectedUser("");
    }
  }, [selected_data]);

  return (
    <>
      {errorVal && (
        <div className="mb-3 w-100">
          <Alert color="danger" className="alert-icon">
            <Icon name="alert-circle" /> {errorVal}
          </Alert>
        </div>
      )}

      {!loading && (
        <div className="mt-2">
          <Link
            onClick={(e) => {
              e.preventDefault();
              refreshList();
            }}
          >
            <Button color="light" outline className="bg-white d-none d-sm-inline-flex">
              <span>Refresh List</span>
            </Button>
          </Link>
        </div>
      )}

      {loading ? (
        <div className="p-5 d-flex align-center justify-center">
          <Spinner />
        </div>
      ) : listError ? (
        <div className="mt-3 p-5 text-soft alert-icon text-center fw-bold fs-15px">
          <BiErrorCircle className="text-danger fs-3" />
          <p>{listError}</p>
        </div>
      ) : (
        <form>
          <Col>
            <TextInput
              label="Search for User"
              type="text"
              id_val="user_search"
              value={onSearchText}
              colSize="6"
              name="user_search"
              handleChange={(e) => onActionText(e.target.value)}
            />
          </Col>

          <p style={{ marginTop: 20 }}>Select a Row to Proceed</p>

          <div className="my-3">
            <ReadOnlyTable
              data={user_list}
              tableType={type}
              setSelectedData={setSelectedData}
              page_size={5}
            />
          </div>

          <Col xl="12">
            <div className="form-group mt-2">
              <div className="form-control-wrap-flex-wrap justify-end">
                {selectedUser ? (
                  <Link to={`/dashboard/onboarding/company/${selectedUser}`}>
                    <Button color="primary" size="lg">
                      <span>Select User</span>
                    </Button>
                  </Link>
                ) : (
                  <Button disabled color="primary" size="lg">
                    <span>Select User</span>
                  </Button>
                )}
              </div>
            </div>
          </Col>
        </form>
      )}
    </>
  );
};

export default ModalOnboardCompanySearch;
